var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4135_34597",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4135_34597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 33.425V26.575L19 23.1V29.95L25 33.425ZM27 33.425L33 29.95V23.1L27 26.575V33.425ZM25 35.725L18 31.7C17.6833 31.5167 17.4375 31.275 17.2625 30.975C17.0875 30.675 17 30.3417 17 29.975V22.025C17 21.6583 17.0875 21.325 17.2625 21.025C17.4375 20.725 17.6833 20.4833 18 20.3L25 16.275C25.3167 16.0917 25.65 16 26 16C26.35 16 26.6833 16.0917 27 16.275L34 20.3C34.3167 20.4833 34.5625 20.725 34.7375 21.025C34.9125 21.325 35 21.6583 35 22.025V29.975C35 30.3417 34.9125 30.675 34.7375 30.975C34.5625 31.275 34.3167 31.5167 34 31.7L27 35.725C26.6833 35.9083 26.35 36 26 36C25.65 36 25.3167 35.9083 25 35.725ZM30 22.525L31.925 21.425L26 18L24.05 19.125L30 22.525ZM26 24.85L27.95 23.725L22.025 20.3L20.075 21.425L26 24.85Z",
    fill: "#008685"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.144bc2ad381fe11f9bb3a91ad8d9832e.svg";
export { ForwardRef as ReactComponent };